/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AccountingTransactionDto = {
    id: number;
    type: AccountingTransactionDto.type;
    status: AccountingTransactionDto.status;
    providerType: AccountingTransactionDto.providerType;
    bookingId?: number | null;
    invoiceNumber?: string | null;
    externalDocumentId?: string | null;
    documentUrl?: string | null;
    clientId?: number | null;
    clientName?: string | null;
    clientEmail?: string | null;
    grossAmount?: string | null;
    netAmount?: string | null;
    taxAmount?: string | null;
    taxRate?: string | null;
    currency: string;
    description?: string | null;
    errorMessage?: string | null;
    createdAt: string;
    completedAt?: string | null;
};
export namespace AccountingTransactionDto {
    export enum type {
        INVOICE_CREATED = 'invoice_created',
        INVOICE_SENT = 'invoice_sent',
        INVOICE_PAID = 'invoice_paid',
        INVOICE_CANCELLED = 'invoice_cancelled',
        CREDIT_NOTE_CREATED = 'credit_note_created',
        REFUND_CREATED = 'refund_created',
        EXPENSE_VOUCHER_CREATED = 'expense_voucher_created',
    }
    export enum status {
        PENDING = 'pending',
        COMPLETED = 'completed',
        FAILED = 'failed',
    }
    export enum providerType {
        LEXOFFICE = 'lexoffice',
        SEVDESK = 'sevdesk',
        TEBUTO = 'tebuto',
    }
}

